/* Perro Loco — Fila de productos que avanza sola
   ------------------------------------------------------------------
   Es la grilla de "Los más vendidos" convertida en fila deslizable: avanza
   UN producto cada cierto rato, con flechas y con el dedo.

   No se hizo dentro de pl-carrusel.js a propósito. Ese muestra UNA
   diapositiva a la vez con `display`, y acá se ven varias tarjetas al mismo
   tiempo: el desplazamiento es real (scroll), no un cambio de diapositiva.
   Meter los dos comportamientos en el mismo archivo habría obligado a
   condicionar cada función.

   El deslizamiento lo hace el navegador con scroll-snap, así que el dedo en el
   celular funciona sin una línea de JavaScript. Este archivo solo agrega el
   avance automático y las flechas.

   El HTML tiene que traer:

     [data-pl-fila]          el contenedor
       [data-intervalo]      ms entre avances; 0 o ausente = no avanza solo
       [data-pista]          la fila con scroll
         > cada hijo         una tarjeta
       [data-fila-antes]     flecha anterior (opcional)
       [data-fila-despues]   flecha siguiente (opcional)

   Reglas, con motivo:

   - Se detiene al pasar el mouse, al enfocar con el teclado, mientras se
     arrastra con el dedo y con la pestaña oculta. Una fila que sigue corriendo
     mientras alguien intenta hacer clic en una tarjeta es una trampa.
   - `prefers-reduced-motion` apaga el avance automático, pero deja las flechas
     y el dedo: esos los pide la persona.
   - Al llegar al final vuelve al principio, sin saltar de golpe.
   - Si las tarjetas ya caben todas sin scroll, no hace nada: no hay nada que
     desplazar y las flechas se esconden.
   ------------------------------------------------------------------ */
(function () {
  'use strict';

  function armar(raiz) {
    if (raiz.dataset.plListo) return;
    raiz.dataset.plListo = '1';

    var pista = raiz.querySelector('[data-pista]');
    if (!pista) return;

    var antes = raiz.querySelector('[data-fila-antes]');
    var despues = raiz.querySelector('[data-fila-despues]');
    var timer = null;
    var sinMovimiento = window.matchMedia('(prefers-reduced-motion: reduce)');

    var intervalo = parseInt(raiz.dataset.intervalo, 10) || 0;
    // Una tarjeta es una foto y un nombre, no un párrafo, así que no necesita
    // los 6 s del banner principal. Bajo 3 s igual se vuelve incómodo.
    if (intervalo && intervalo < 3000) intervalo = 3000;

    function paso() {
      var primera = pista.firstElementChild;
      if (!primera) return pista.clientWidth;
      var estilo = window.getComputedStyle(pista);
      var hueco = parseFloat(estilo.columnGap || estilo.gap || '0') || 0;
      return primera.getBoundingClientRect().width + hueco;
    }

    function hayQueDesplazar() {
      return pista.scrollWidth - pista.clientWidth > 4;
    }

    function mover(dir) {
      if (!hayQueDesplazar()) return;
      var fin = pista.scrollWidth - pista.clientWidth;
      // El margen de 4 px absorbe el redondeo del navegador: sin él, "llegué
      // al final" a veces no se cumple nunca y la fila queda pegada.
      if (dir > 0 && pista.scrollLeft >= fin - 4) {
        pista.scrollTo({ left: 0, behavior: 'smooth' });
        return;
      }
      if (dir < 0 && pista.scrollLeft <= 4) {
        pista.scrollTo({ left: fin, behavior: 'smooth' });
        return;
      }
      pista.scrollBy({ left: dir * paso(), behavior: 'smooth' });
    }

    function arrancar() {
      if (!intervalo) return;
      if (sinMovimiento.matches) return;
      if (!hayQueDesplazar()) return;
      detener();
      timer = setInterval(function () { mover(1); }, intervalo);
    }

    function detener() {
      if (timer) {
        clearInterval(timer);
        timer = null;
      }
    }

    function acomodarFlechas() {
      var visible = hayQueDesplazar();
      [antes, despues].forEach(function (b) {
        if (b) b.hidden = !visible;
      });
      if (!visible) detener();
    }

    if (antes) antes.addEventListener('click', function () { mover(-1); arrancar(); });
    if (despues) despues.addEventListener('click', function () { mover(1); arrancar(); });

    raiz.addEventListener('mouseenter', detener);
    raiz.addEventListener('mouseleave', arrancar);
    raiz.addEventListener('focusin', detener);
    raiz.addEventListener('focusout', arrancar);
    pista.addEventListener('pointerdown', detener);
    pista.addEventListener('pointerup', arrancar);
    document.addEventListener('visibilitychange', function () {
      if (document.hidden) { detener(); } else { arrancar(); }
    });
    window.addEventListener('resize', acomodarFlechas);
    if (sinMovimiento.addEventListener) {
      sinMovimiento.addEventListener('change', function () {
        if (sinMovimiento.matches) { detener(); } else { arrancar(); }
      });
    }

    acomodarFlechas();
    arrancar();
  }

  function armarTodo() {
    var filas = document.querySelectorAll('[data-pl-fila]');
    for (var i = 0; i < filas.length; i++) armar(filas[i]);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', armarTodo);
  } else {
    armarTodo();
  }
  // El personalizador vuelve a dibujar la sección sin recargar la página.
  document.addEventListener('shopify:section:load', armarTodo);
})();
